<template>
  <div class="event-status-selection" :class="{'event-status-selection-fix-top': fixElementChild}">
    <div class="title margin-side" :class="{'display-none-something': false}">Event Status</div>
    <div class="list-status margin-side row" :class="{'list-status-fix-top': fixElementChild}">
      <ul class="list">
        <li class="item" v-for="item in listEventStatus" :key="item.text">
          <div class="status">
            {{ item.text }}
          </div>
          <div class="count">
            {{ countEventByStatus(item.text) }}
          </div>
        </li>
      </ul>
      <div class="icon-wrapper" :class="{'active-wrapper': isShowAction}" @click="isShowAction = true" @mouseleave="isShowAction = false">
        <Icon class="icon-filter" :class="{'active': isShowAction}" :name="'filter'"></Icon>
        <ul class="action-panel" v-if="isShowAction">
          <div class="title">Display</div>
          <li v-for="item in listEventStatus" :key="item.text">
            <div class="input-checkbox" :class="{'checkbox-active': item.isCheck}">{{ item.text }}
              <input v-model="item.isCheck" type="checkbox" @click="selectStatus(item)">
              <span class="checkmark"></span>
            </div>
          </li>
        </ul>
      </div>
      <div :class="{'display-none-something': !fixElementChild, 'scrollIcon': fixElementChild}">
        <ScrollTop></ScrollTop>
      </div>
    </div>
    <TableHeader class="table-header-fix-position" v-if="fixElementChild"></TableHeader>
  </div>
</template>

<script>
  import 'vue-awesome/icons/filter';
  import Icon from 'vue-awesome/components/Icon';
  import {mapActions, mapGetters} from 'vuex';
  import TableHeader from '../datatable/TableHeader'
  import consts from '../../_consts';
  import ScrollTop from '../utils/ScrollTop';
  export default {
    name: 'event-status-selection',
    components: {
      Icon,
      TableHeader,
      ScrollTop
    },
    props: {
    },
    data () {
      return {
        listEventStatus: [
          {
            text: 'Drafts',
            count: 200,
            isCheck: false
          },
          {
            text: 'Submitted',
            count: 0,
            isCheck: false
          },
          {
            text: 'Review',
            count: 100,
            isCheck: false
          },
          {
            text: 'Approved',
            count: 101,
            isCheck: false
          },
          {
            text: 'Archived',
            count: 1,
            isCheck: false
          }
        ],
        isShowAction: false,
        fixElementChild: false,
        listChecked: []
      }
    },
    methods: {
      selectStatus (item) {
      },
      handleScroll () {
        this.fixElementChild = window.scrollY >= 180;
      },
      getListEventParams: function (statuses) {
        return {
          userId: Number(localStorage.getItem(consts.LOCAL_STORE.userId)),
          status: statuses,
          options: [],
          clientId: Number(localStorage.getItem(consts.LOCAL_STORE.clientId))
        };
      },
      ...mapActions({
        getEventsByStatuses: 'ACTION_GET_EVENT_LIST',
        getEventCountByClientId: 'ACTION_GET_EVENT_COUNT_BY_CLIENT'
      })
    },
    computed: {
      ...mapGetters({
        countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS'
      })
    },
    mounted () {
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
      this.listChecked = [];
      this.getEventCountByClientId().then(function () {});
    },
    watch: {
      listEventStatus: {
        handler: function (val, oldVal) {
          this.listChecked = [];
          val.forEach(item => {
            if (item.isCheck) {
              this.listChecked.push(item.text.toUpperCase());
            }
          });
          this.getEventsByStatuses(this.getListEventParams(this.listChecked));
        },
        deep: true
      }
    }
  };
</script>

<style lang="less">
  @import "../../styles/variables.less";
  .event-status-selection{
    background-color: @white;
    font-family: @font-family-main;
    color: @black-1;
    padding-top: 15px;
    width: 100%;
    &.fix-element-to-top{
    }

    .table-header-fix-position{
      background-color: @grey-5;
      padding-left: 24px;
      padding-right: 24px;
    }

    &.event-status-selection-fix-top {
      transition: top .2s ease-in;
      padding-top: 0;
      height: 89px;
      position: fixed;
      top: -20px;
      z-index: 1000;
    }
    .scrollIcon {
      position: absolute;
      top: 20;
      right: 0;
    }
    .display-none-something {
      display: none;
    }
    .title{
      font-size: 12px;
      letter-spacing: 0.1px;
      // margin-top: 15px;
      height: 20px;
      text-transform: uppercase;
    }
    .list-status-fix-top {
      height: 44px !important;
    }
    .list-status{
      margin-top: 5px;
      margin-left: 0;
      margin-right: 0;
      height: 53px;
      .list{
        list-style: none;
        margin: 0;
        padding: 0;
        .item{
          float: left;
          width: 100px;
          .status{
            font-size: 12px;
            color: @black-2;
          }
          .count{
            font-size: 16px;	font-weight: bold;
          }
        }
      }
      .active-wrapper{
        border-color: @dark-blue-2 !important;
        background-color: @dark-blue-2;
      }
      .icon-wrapper{
        border: solid 1px @light-blue;
        border-radius: 3px;
        width: 32px;
        height: 32px;
        margin-top: 5px;
        position: relative;
        text-align: center;
        &:hover{
          cursor: pointer;
        }
        .icon-filter{
          margin: 1.5px 1.5px;
          width: 27px;
          height: 27px;
          color: @light-blue;
          background-color: @light-blue;
          -webkit-mask: url('../../../static/img/sort_black.svg') no-repeat center;
          mask: url('../../../static/img/sort_black.svg') no-repeat center;
          background: url('../../../static/img/sort_blue.svg');
        }
        .active{
          color: @white;
          background-color: @white;

          &.icon-filter{
            /*-webkit-mask: unset;*/
            /*mask: unset;*/
            background: url('../../../static/img/filter-white.svg');
          }
        }
        ul.action-panel {
          list-style: none;
          font-size: 12px;
          line-height: 26px;
          text-align: left;
          padding: 15px;
          margin-bottom: 0;
          border-radius: 3px;
          background-color: @white;
          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
          position: absolute;
          top: 32px;
          left: 0;
          width: 200px;
          z-index: 9999;
          .title{
            font-size: 12px;
            letter-spacing: 0.1px;
            line-height: 16px;
            color: @black-1;
          }
          li {
            // padding-left: 10px;
            // border-bottom: solid 1px #E6E6E6;
            &:last-child {
              border-bottom: none;
            }
            .checkbox-active{
              color: @light-blue !important;
              font-weight: bold;
            }
            .input-checkbox {
              display: block;
              position: relative;
              padding-left: 20px;
              margin-bottom: 0px;
              // cursor: pointer;
              color: @black-2;
              // font-size: 22px;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
              input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                left: 0;
                bottom: 6px;
                width: 16px;
                height: 16px;
                z-index: 10;
              }
              .checkmark {
                position: absolute;
                top: 4px;
                left: 0;
                height: 16px;
                width: 16px;
                background-color: #FFFFFF;
                border: solid 1px @grey-3;
                z-index: 1;
                &::after{
                  left: 6px;
                  top: 2px;
                  width: 5px;
                  height: 10px;
                  border: solid white;
                  border-width: 0 2px 2px 0;
                  -webkit-transform: rotate(45deg);
                  -ms-transform: rotate(45deg);
                  transform: rotate(45deg);
                  content: "";
                  position: absolute;
                  display: none;
                }
              }
            }
            /* On mouse-over, add a grey background color */
            .input-checkbox:hover input ~ .checkmark {
              // background-color: @white;
              // cursor: pointer;
            }

            /* When the checkbox is checked, add a blue background */
            .input-checkbox input:checked ~ .checkmark {
              background-color: @light-blue;
              color: @light-blue;
              border: none;
            }
            /* Show the checkmark when checked */
            .input-checkbox input:checked ~ .checkmark:after {
              display: block;
            }
            .input-checkbox ~ .checkmark:after {
              color: @light-blue;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// EventStatusSelection.vue?6e626faf